import React from "react";
import { HiOutlineTrophy } from "react-icons/hi2";

const ScoreCard = ({ overall }) => {
  if (!overall) return null;

  const { percentage = 0 } = overall;
  return (
    <div className="w-full flex justify-center items-center py-6 md:py-10 animate-in fade-in zoom-in duration-500">
      <div className="bg-white w-full max-w-[306px] rounded-[7px] shadow-md border-t-2 border-[#E63946] flex flex-col items-center py-5 transition-transform hover:scale-105 duration-300">
        <div className="bg-[#E63946] w-[70px] h-[70px] md:w-[85px] md:h-[85px] rounded-full flex items-center justify-center shadow-inner">
          <HiOutlineTrophy className="text-white text-[32px] md:text-[40px]" />
        </div>
        <p className="text-[#E63946] font-[600] text-[20px] md:text-[24px] mt-3">
          {percentage}%
        </p>
        <p className="text-[#333333] font-[500] tracking-tight text-[16px] md:text-[20px]">
          Overall Score
        </p>
      </div>
    </div>
  );
};

export default ScoreCard;
